<div class="find-accountingfirm-container">
  <flowaccount-accountingfirm-intro></flowaccount-accountingfirm-intro>

  <!-- ทำเสร็จแล้ว + รอทีมคุณซินดดี้เทสช่วงปลายสัปดาห์ ต้องการคัดเรื่องนี้เข้า main และ rebase code ไปรวมกันอีก branch นึงที่มีงานอื่นเกี่ยวข้องกันครับ-->
  <ng-container *ngIf="true">
    <flowaccount-testimonial-partner></flowaccount-testimonial-partner>
  </ng-container>

  <flowaccount-accountingfirm-benefits></flowaccount-accountingfirm-benefits>

  <flowaccount-accountingfirm-introduce></flowaccount-accountingfirm-introduce>

  <flowaccount-accountingfirm-find [accountingFirmDisplayType]="'recommend'"></flowaccount-accountingfirm-find>

  <flowaccount-accountingfirm-register></flowaccount-accountingfirm-register>

  <!-- Blog -->
  <flowaccount-blog-swiper-squidex
    [customHeader]="customHeader"
    [lang]="translate.currentLang"
    [contentSquidex]="'businessowner-blog'"
    [contentScully]="'businessowner-blog-key'"
  ></flowaccount-blog-swiper-squidex>
</div>

<flowaccount-starter-kit-shared></flowaccount-starter-kit-shared>
